import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'mcfs42',
  Description:
    'Here\'s all the online content included with your <strong>GCSE Mathematics Complete Revision & Practice</strong>.',
  Credits:
    '<i>Contributor: Alastair Duncombe.<br />Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved. <br /> <br /></i>',};